import type { AxiosInstance } from 'axios'
import authorization from '@shared/utils/authorization'
import { installRequestInterceptor } from '@shared/utils/interceptors/requestInterceptor'
import type { CognitoUserSession } from 'amazon-cognito-identity-js'
import notification from '@shared/components/ui/c-notification'
import { ENotificationType } from '@shared/types/constants/notification-type'
import { saveLogoutRoute } from '@shared/utils/router-logout-saver'

export const installResponseInterceptor = ({ apiClient }: { apiClient: AxiosInstance }) => {
  apiClient.interceptors.response.clear()
  apiClient.interceptors.response.use(
    response => response.data,
    async error => {
      if (error.response?.status === 401 && !authorization.isLoading) {
        notification.open({
          message: error.response.data,
          type: ENotificationType.ERROR,
        })
        const customToken = localStorage.getItem('customToken')
        if (customToken) {
          localStorage.removeItem('customToken')
          location.reload()
        }
        try {
          await authorization.refreshSession()
          const session: CognitoUserSession | null = await authorization.loadPersisted()
          const sessionToken: string | null = session ? session.getIdToken().getJwtToken() : null
          installRequestInterceptor({
            apiClient,
            sessionToken,
          })
          notification.open({
            message: 'Access token was automatically refreshed',
          })
        } catch (e) {
          saveLogoutRoute({
            user: authorization.user,
          })
        }
      }

      throw error
    }
  )
}
